namespace TabAurous.HR {
    export interface PayrollRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        LedgerId?: number;
        PayrollFrequency?: Common.PayrollFrequency;
        BranchId?: number;
        DesignationId?: number;
        DepartmentId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        UserId?: number;
        Details?: PayrollDetailsRow[];
    }

    export namespace PayrollRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'HR.Payroll';
        export const deletePermission = 'HR:Payroll:Delete';
        export const insertPermission = 'HR:Payroll:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:Payroll:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            LedgerId = "LedgerId",
            PayrollFrequency = "PayrollFrequency",
            BranchId = "BranchId",
            DesignationId = "DesignationId",
            DepartmentId = "DepartmentId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            Details = "Details"
        }
    }
}
